import request from './request.js';
import {requestbody} from './request.js'

export async function queryExportBusinessSituation(params = {}) {
    return await requestbody('/manuscript/queryExportBusinessSituation', 'post', params)
}

export async function saveExportBusinessSituation(params = {}) {
    return await requestbody('/manuscript/saveExportBusinessSituation', 'post', params)
}

export async function queryCurrentPeriodExportBusinessSituation(params = {}) {
    return await requestbody('/manuscript/queryCurrentPeriodExportBusinessSituation', 'post', params)
}
//根据公司id查询公司基础信息
export async function company(params = {}) {
    return await request('/manuscript/query/company', 'post', params)
}

// 出口收入差异情况表
export async function queryExportIncomeDifference(params = {}) {
    return await requestbody('/manuscript/queryExportIncomeDifference', 'post', params)
}

export async function saveExportIncomeDifference(params = {}) {
    return await requestbody('/manuscript/saveExportIncomeDifference', 'post', params)
}